import type { SiteNamesMatchingClassification } from '@seek/melways-sites';

import type { SearchIntegrationPartnersQuery } from './App/generated/graphql-types';

declare global {
  interface Window {
    __config: ConfigContextTypes;
    currentPageTrackingData: PageTrackingProps;
  }
}

interface PageTrackingProps {
  page: string;
  eventName: string;
  loginStatus?: string;
  siteSection?: string;
  subSection?: string;
}

export enum Environment {
  PROD = 'production',
  DEV = 'development',
  STAG = 'staging',
}

export type Site = SiteNamesMatchingClassification<{
  product: 'employer';
  country: 'au' | 'nz' | 'hk' | 'th' | 'sg' | 'id' | 'ph' | 'my';
}>;

export type Language =
  | 'en-AU'
  | 'en-HK'
  | 'en-ID'
  | 'en-MY'
  | 'en-NZ'
  | 'en-PH'
  | 'en-SG'
  | 'en-TH'
  | 'th-TH'
  | 'id-ID';

export type Locale = 'AU' | 'NZ' | 'TH' | 'ID' | 'MY' | 'HK' | 'PH' | 'SG';

export interface ConfigContextTypes {
  environment: Environment;
  locale: Locale;
  language: Language;
  site: Site;
  data?: any;
  route: string;
  version: string;
}

export interface PageProps {
  title?: string;
  slug: string;
  routes?: any;
}

export interface RouteProps {
  name: string;
  path: string;
  tracking: string;
}

export type Partner =
  SearchIntegrationPartnersQuery['searchIntegrationPartners'][number];

export type RelationshipTypeCode =
  | 'JOB_POSTING'
  | 'APPLICATION_EXPORT'
  | 'APPLICATION_PREFILL';

export type RequireAtLeastOne<T> = {
  [K in keyof T]: Required<Pick<T, K>> & Partial<Pick<T, Exclude<keyof T, K>>>;
}[keyof T];
